import { gql } from '@apollo/client';

export const GET_EXCHANGE_READY_FILES = gql`
  query EDI_SERVICE_getExchangeReadyFiles($sponsorId: ID!, $setAsSent: Boolean = false) {
    getExchangeReadyFiles(sponsorId: $sponsorId, setAsSent: $setAsSent) {
      id
      fileName
      fileLocation
      generatedFrom {
        policyId
        productLineId
      }
      creationDate
      exchangeState
    }
  }
`;
